import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterChatMessage } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterChatMessage>();

export class CallCenterChatMessageFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterChatMessage>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterChatMessage)(filters);
  });
}
